import styled from "styled-components";
import { styleSheet } from "../../assets/styles/global";
import TimePicker from '@mui/lab/TimePicker';
import { Input, InputProps, Select, SelectProps } from 'semantic-ui-react'

export const Schedules = styled.div`
  position: relative;
  width: 50%;
  padding: 0 4rem;
  margin: 4rem 0;
`;

export const TimeContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

export const TimeTitle = styled.h3`
  width: 30%;
  font-size: 2rem;
  color: ${styleSheet.colorMain};
  align-self: flex-end;
`;

export const FieldContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const IntervalContainer = styled.div`
  width: 100%;
  margin: 4rem auto;
  padding: 0 4rem;
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin: 4rem auto;
`;

export const Title = styled.h2`
  font-size: 2rem;
  color: ${styleSheet.colorMain};
  text-align: left;
  margin-bottom: 2rem;
`;

export const InputWorkerHours = styled.input`
  text-align: center; 
  outline: 0;
  border: 0;
  background: transparent;
  /* -webkit-appearance: none; */
`;

export const SelectContainer = styled(Select)<SelectProps>`
  width: 100%;
  /* height: 40px; */
  padding: 3px;
  border: 1px solid #000;
  border-radius: 5px;

`;

export const Option = styled.option`
  display: flex;
  white-space: pre;
  min-height:  40px;
  padding: 3px;
  border-radius: 5px;
`;

export const OSDetail = styled.div`
  width: 40%;
  padding: 0 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OSDetailTitle = styled.h2`
  align-self: flex-start;
  font-size: 2rem;
  color: ${styleSheet.colorMain};
`;

export const TableColumnText = styled.span`
  font-size: 1.2rem;
  white-space: nowrap;
`;

export const TableDataText = styled.span`
  font-size: 1.2rem;
  white-space: nowrap;
`;

export const ButtonTable = styled.button`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 1.75rem;
  border: 0;
  margin-right: .5rem;
  background: transparent;
  cursor: pointer;
`;


















